export const environment = {
  production: false,//https://api-sandbox.scripay.com
  apiUrl: 'https://api-sandbox.scripay.com/v1/gateway/',
};
